/**
 * Main App Component
 * 
 * Handles routing between login and main chat interface.
 * Manages global state and authentication flow.
 */

import { useState } from 'react';
import { useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';

const App = () => {
  const { isAuthenticated, loading } = useAuth();
  const [selectedChat, setSelectedChat] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  /**
   * Handle chat selection
   */
  const handleSelectChat = (chatId, user) => {
    setSelectedChat(chatId);
    setSelectedUser(user);
  };

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto mb-4" />
          <p className="text-gray-600">Loading YTag Chat...</p>
        </div>
      </div>
    );
  }

  // Show login screen if not authenticated
  if (!isAuthenticated) {
    return <Login />;
  }

  // Show main dashboard if authenticated
  return (
    <Dashboard
      selectedChat={selectedChat}
      selectedUser={selectedUser}
      onSelectChat={handleSelectChat}
    />
  );
};

export default App;
